var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloudFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 2C6.66875 2 4.68125 3.72 4.25 6C2.1875 6 0.5 7.8 0.5 10C0.5 12.2 2.1875 14 4.25 14H12.6875C14.2437 14 15.5 12.66 15.5 11C15.5 9.7 14.7125 8.42 13.625 8V7C13.625 4.24 11.525 2 8.9375 2Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudFill);
export default __webpack_public_path__ + "static/media/icon-cloud-fill.c305a946433aacd75af1f94247735820.svg";
export { ForwardRef as ReactComponent };